import { createSelector } from '@ngrx/store';
import { SmartSearchFormValues } from '@shared-lib/forms/sign-up-smart-search/smart-search.form';
import { selectSignUpState } from '@shared/store/sign-up/sign-up.selectors';

export const selectSignUpSmartSearchState = createSelector(selectSignUpState, (state) => state.smartSearch);

export const selectSignUpSmartSearchData = createSelector(
  selectSignUpSmartSearchState,
  (smartSearchState): SmartSearchFormValues | null => smartSearchState.entity,
);

export const selectSignUpSmartSearchIsLoading = createSelector(
  selectSignUpSmartSearchState,
  (smartSearchState): boolean => smartSearchState.loading,
);
